import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface IChatwootStore {
  isActive: boolean;
  isLoading: boolean;
  isInit: boolean;
  setIsActive: (status: boolean) => void;
  setIsLoading: (loading: boolean) => void;
  setIsInit: (init: boolean) => void;
}

export const useChatWootStore = createWithEqualityFn<IChatwootStore>()(
  devtools(
    (set) => ({
      isActive: false,
      isLoading: false,
      isInit: false,
      setIsActive: (status: boolean) => {
        set({ isActive: status });
      },
      setIsLoading: (loading: boolean) => {
        set({ isLoading: loading });
      },
      setIsInit: (init: boolean) => {
        set({ isInit: init });
      },
    }),
    { name: "ChatWoot Store" },
  ),
  shallow,
);
